import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled(Box)`
  background-color: white;
  border-radius: 12px;
  width: 50vw; /* Default width for larger screens */
  max-width: 700px; /* Limit maximum width */
  min-width: 300px; /* Set a minimum width */
  max-height: 90vh; /* Limit height to 80% of viewport height */
  height: auto; /* Allow height to adjust based on content */
  overflow-y: auto; /* Enable scrolling if content overflows */
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  padding-bottom: 25px;

  @media (max-width: 1024px) {
    width: 70vw; /* Adjust width on medium screens */
  }

  @media (max-width: 768px) {
    width: 85vw; /* Increase width on smaller screens */
  }

  @media (max-width: 480px) {
    width: 90vw; /* Full width for extra small screens */
    max-height: 90vh; /* More vertical space on very small screens */
  }
`;

const CloseDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
`;

const IframeWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  border-radius: 20px;
`;

const LoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  border-radius: 20px;
`;

const FeedbackFormModal = ({ open, onClose }) => {
  const [isLoaded, setIsLoaded] = useState(false); // Track iframe load state

  const { userProfile } = useSelector((state) => state.userProfile);

  // Add null check and default values
  const first_name = userProfile?.first_name || '';
  const last_name = userProfile?.last_name || '';
  const email = userProfile?.email || '';

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.iyuga.net/js/form_embed.js";
    script.async = true;
    script.onload = () => console.log("Form embed script loaded");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const iframeSrc = `https://link.iyuga.net/widget/form/7UqAPUhwMUZufxa6NKdf?first_name=${encodeURIComponent(
    first_name
  )}&last_name=${encodeURIComponent(last_name)}&email=${encodeURIComponent(
    email
  )}`;

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalContainer>
        <CloseDiv>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </CloseDiv>

        {!isLoaded && (
          <LoaderWrapper>
            <CircularProgress /> {/* Show loader until iframe is ready */}
          </LoaderWrapper>
        )}

        <IframeWrapper>
          <StyledIframe
            src={iframeSrc}
            id="inline-7UqAPUhwMUZufxa6NKdf"
            title="Bug Feedback Form"
            onLoad={() => setIsLoaded(true)} // Set isLoaded to true when iframe loads
          ></StyledIframe>
        </IframeWrapper>
      </ModalContainer>
    </StyledModal>
  );
};

export default FeedbackFormModal;
